import { ApplicationFinalStage } from '@App/interfaces/application-final-stage';
import { ApplicationStage } from '@App/interfaces/application-stage.enum';
import { axiosInstance } from '@App/providers';
import {
    getRequestConfigWithUserProfile,
    httpErrorResponse,
} from '@App/requests/shared';

export const patchApplicationStage = async (
    id: string,
    finalStage: ApplicationFinalStage,
    applicationStage: ApplicationStage | '',
    accessToken: string,
    idToken: string,
) => {
    const url = window._env_.MS_D2C_BASE_URL as string;

    try {
        await axiosInstance.patch(
            `${url}/v2/application/${id}/stage`,
            {
                stage: finalStage,
                applicationStage,
            },
            getRequestConfigWithUserProfile(accessToken, idToken),
        );
        return { success: true };
    } catch (e) {
        return httpErrorResponse(e);
    }
};
